import { Box, Stack, Typography } from "@mui/material";
import versantWordmark from "assets/logo/Versant_Wordmark.png";
import {
  brandLockupLogoImageSx,
  brandLockupRootSx,
  brandLockupTextWrapperSx,
  getBrandLockupLogoSx,
  getBrandLockupTitleSx,
} from "./brandLockupStyles";

interface BrandLockupProps {
  compact?: boolean;
  hideTitleOnMobile?: boolean;
  inverted?: boolean;
}

export default function BrandLockup({
  compact = false,
  hideTitleOnMobile = false,
  inverted = false,
}: BrandLockupProps) {
  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={brandLockupRootSx}>
      <Box sx={(theme) => getBrandLockupLogoSx(theme, compact, inverted)}>
        <Box component="img" src={versantWordmark} alt="Versant" sx={brandLockupLogoImageSx} />
      </Box>

      <Box sx={brandLockupTextWrapperSx}>
        <Typography
          variant="h4"
          color={inverted ? "common.white" : "text.primary"}
          sx={getBrandLockupTitleSx(compact, hideTitleOnMobile)}
        >
          Recon Tool
        </Typography>
      </Box>
    </Stack>
  );
}
